import * as React from 'react';

import PanelPersona, { Datos as PersonaDatos, inicial as personaInicial } from '../PanelPersona';
import RelacionConAlumno, {
    Datos as RelacionConAlumnoDatos,
    inicial as relacionConAlumnoInicial,
} from '../RelacionConAlumno';

export interface Datos extends PersonaDatos {
    relacionConAlumno: RelacionConAlumnoDatos;
}

export const inicial: Datos = {
    ...personaInicial,
    ocupacion: { id: 'Trabajador', otro: '' },
    relacionConAlumno: { ...relacionConAlumnoInicial, id: 'Padre', otro: '' },
};

interface Props {
    mostrar: boolean;
    apoderado: Datos;
    onChange(apoderado: Datos): void;
}

class Apoderado extends React.PureComponent<Props> {
    public render() {
        const { mostrar, apoderado, onChange } = this.props;

        return (
            <PanelPersona
                titulo='Datos del apoderado'
                mostrar={mostrar}
                persona={apoderado}
                onChange={onChange}
            >
                <RelacionConAlumno
                    mostrar={mostrar}
                    relacionConAlumno={apoderado.relacionConAlumno}
                    onChange={valor => {
                        onChange({
                            ...apoderado,
                            relacionConAlumno: valor,
                        });
                    }}
                />
            </PanelPersona>
        );
    }
}

export default Apoderado;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S2Apoderado/index.tsx